// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__35-5u","Title":"Alert_Title__3HhYo","Description":"Alert_Description__zbD4T"};